(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    function updateCartLine(line, quantity) {
      var btns = document.querySelectorAll('.cart-item__qty-btn');
      btns.forEach(function (b) { b.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line + 1, quantity: quantity })
      })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btns.forEach(function (b) { b.disabled = false; });
        });
    }

    document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.index, 10);
        var input = document.querySelector('.cart-item__qty-input[data-index="' + idx + '"]');
        if (!input) return;
        var val = parseInt(input.value, 10) || 0;
        var newVal = btn.dataset.action === 'plus' ? val + 1 : Math.max(0, val - 1);
        input.value = newVal;
        updateCartLine(idx, newVal);
      });
    });

    document.querySelectorAll('.cart-item__qty-input').forEach(function (input) {
      var timer;
      input.addEventListener('change', function () {
        clearTimeout(timer);
        var idx = parseInt(input.dataset.index, 10);
        var newVal = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = newVal;
        timer = setTimeout(function () { updateCartLine(idx, newVal); }, 400);
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conseils-recettes"]) return;
  try {
    
  (function () {
    var items = document.querySelectorAll('.conseil-item');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var burger = header.querySelector('.header__burger');
    var mobileNav = document.getElementById('mobile-nav');
    var backdrop = document.getElementById('mobile-backdrop');

    function updateScrolled() {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }
    window.addEventListener('scroll', updateScrolled, { passive: true });
    updateScrolled();

    function toggleMenu(open) {
      burger.classList.toggle('is-open', open);
      mobileNav.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    burger.addEventListener('click', function() {
      toggleMenu(!burger.classList.contains('is-open'));
    });
    backdrop.addEventListener('click', function() { toggleMenu(false); });
    var closeBtn = document.getElementById('mobile-nav-close');
    if (closeBtn) closeBtn.addEventListener('click', function() { toggleMenu(false); });

    var searchToggle = document.getElementById('search-toggle');
    var searchForm = document.getElementById('header-search-form');
    var searchInput = document.getElementById('search-input');

    function toggleSearch(open) {
      header.classList.toggle('header--search-open', open);
      searchToggle.classList.toggle('is-active', open);
      searchToggle.setAttribute('aria-expanded', open);
      if (searchForm) searchForm.setAttribute('aria-hidden', !open);
      if (open && searchInput) searchInput.focus();
    }

    searchToggle.addEventListener('click', function() {
      toggleSearch(!header.classList.contains('header--search-open'));
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') toggleSearch(false);
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('#header-search-form') && !e.target.closest('#search-toggle')) {
        toggleSearch(false);
      }
    });

    // Desktop dropdowns — hover (CSS) + keyboard support
    header.querySelectorAll('.header__nav-item--dropdown').forEach(function(item) {
      var btn = item.querySelector('.header__nav-link--parent');

      // Keyboard: Enter/Space toggle, Escape close
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = item.classList.contains('is-open');
          header.querySelectorAll('.header__nav-item--dropdown.is-open')
            .forEach(function(i) { i.classList.remove('is-open'); i.querySelector('.header__nav-link--parent').setAttribute('aria-expanded', 'false'); });
          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        }
        if (e.key === 'Escape') {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      });

      // Close on mouseleave (only when not keyboard-opened)
      item.addEventListener('mouseleave', function() {
        if (!item.dataset.keyboardOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header__nav-item--dropdown')) {
        header.querySelectorAll('.header__nav-item--dropdown.is-open').forEach(function(i) {
          i.classList.remove('is-open');
          i.querySelector('.header__nav-link--parent').setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Mobile accordion
    document.querySelectorAll('.mobile-nav__accordion-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var accordion = btn.closest('.mobile-nav__accordion');
        var body = accordion.querySelector('.mobile-nav__accordion-body');
        var isOpen = accordion.classList.contains('is-open');
        // Close others
        document.querySelectorAll('.mobile-nav__accordion.is-open').forEach(function(a) {
          a.classList.remove('is-open');
          a.querySelector('.mobile-nav__accordion-body').setAttribute('aria-hidden', 'true');
          a.querySelector('.mobile-nav__accordion-btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          accordion.classList.add('is-open');
          body.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var variantsEl = document.getElementById('product-variants-data');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var mainImg = document.getElementById('product-gallery-main');
    var variantInput = document.getElementById('product-variant-id');
    var selects = document.querySelectorAll('.product-form__select');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');

    function setMainImage(src, alt) {
      if (!mainImg) return;
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.alt = alt || '';
    }

    function findVariant() {
      var options = Array.from(selects).map(function(s) { return s.value; });
      return variants.find(function(v) {
        return options.every(function(opt, i) { return v['option' + (i + 1)] === opt; });
      });
    }

    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        var variant = findVariant();
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (variant.featured_image) {
          var src = variant.featured_image.src.split('?')[0] + '?width=1000';
          setMainImage(src, variant.featured_image.alt || variant.title);
        }
      });
    });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setMainImage(this.dataset.imageUrl, this.dataset.alt);
        thumbs.forEach(function(t) { t.classList.remove('product-gallery__thumb--active'); });
        this.classList.add('product-gallery__thumb--active');
      });
    });

    var minusBtn = document.querySelector('.product-form__qty-btn:first-child');
    var plusBtn = document.querySelector('.product-form__qty-btn:last-child');
    var qtyInput = document.getElementById('product-qty');
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function() {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.getElementById('recipe-track');
    if (!track) return;

    var stage = track.parentElement;
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var animPaused = false;

    stage.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - stage.offsetLeft;
      scrollLeft = stage.scrollLeft;
      track.style.animationPlayState = 'paused';
    });

    stage.addEventListener('mouseleave', function () {
      if (isDown) track.style.animationPlayState = 'running';
      isDown = false;
    });

    stage.addEventListener('mouseup', function () {
      isDown = false;
      track.style.animationPlayState = 'running';
    });

    stage.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - stage.offsetLeft;
      var walk = (x - startX) * 1.5;
      stage.scrollLeft = scrollLeft - walk;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restaurants-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRestaurantsMap() {
      var dataEl = document.getElementById('restaurants-data');
      var mapEl = document.getElementById('restaurants-map');
      if (!dataEl || !mapEl || typeof L === 'undefined') return;

      var restaurants = JSON.parse(dataEl.textContent);
      var cards = document.querySelectorAll('.restaurant-card');

      var map = L.map('restaurants-map', { zoomControl: false });

      L.control.zoom({ position: 'bottomright' }).addTo(map);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 18,
      }).addTo(map);

      var pinIcon = function (num) {
        return L.divIcon({
          className: '',
          html: '<div class="map-pin"><span>' + num + '</span></div>',
          iconSize: [36, 36],
          iconAnchor: [18, 36],
          popupAnchor: [0, -38],
        });
      };

      var markers = [];

      restaurants.forEach(function (r, i) {
        if (!r.lat || !r.lng || (r.lat == 0 && r.lng == 0)) return;

        var marker = L.marker([r.lat, r.lng], { icon: pinIcon(i + 1) }).addTo(map);

        var popup = '<strong>' + r.name + '</strong><br>' + r.address + '<br>' + r.city;
        if (r.phone) popup += '<br><a href="tel:' + r.phone.replace(/\s/g, '') + '">' + r.phone + '</a>';
        marker.bindPopup(popup);
        markers.push(marker);

        if (cards[i]) {
          cards[i].addEventListener('click', function () {
            map.flyTo([r.lat, r.lng], 14, { duration: 0.8 });
            marker.openPopup();
            cards.forEach(function (c) {
              c.classList.remove('restaurant-card--active');
            });
            cards[i].classList.add('restaurant-card--active');
          });

          marker.on('click', function () {
            cards.forEach(function (c) {
              c.classList.remove('restaurant-card--active');
            });
            cards[i].classList.add('restaurant-card--active');
            cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
        }
      });

      if (markers.length > 0) {
        var group = L.featureGroup(markers);
        map.fitBounds(group.getBounds().pad(0.15));
      } else {
        map.setView([42.6, 2.5], 9);
      }
    }

    var mapContainer = document.getElementById('restaurants-map');
    if (!mapContainer) return;

    var script = document.createElement('script');
    script.src = mapContainer.dataset.leafletUrl;
    script.onload = initRestaurantsMap;
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revendeurs-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRevendeursMap() {
      var dataEl = document.getElementById('revendeurs-data');
      var mapEl = document.getElementById('revendeurs-map');
      if (!dataEl || !mapEl || typeof L === 'undefined') return;

      var revendeurs = JSON.parse(dataEl.textContent);
      var cards = document.querySelectorAll('.revendeur-card');

      var map = L.map('revendeurs-map', { zoomControl: false });

      L.control.zoom({ position: 'bottomright' }).addTo(map);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 18,
      }).addTo(map);

      var pinIcon = function (num) {
        return L.divIcon({
          className: '',
          html: '<div class="map-pin"><span>' + num + '</span></div>',
          iconSize: [36, 36],
          iconAnchor: [18, 36],
          popupAnchor: [0, -38],
        });
      };

      var markers = [];

      revendeurs.forEach(function (r, i) {
        if (!r.lat || !r.lng || (r.lat == 0 && r.lng == 0)) return;

        var marker = L.marker([r.lat, r.lng], { icon: pinIcon(i + 1) }).addTo(map);

        var popup = '<strong>' + r.name + '</strong><br>' + r.address + '<br>' + r.city;
        if (r.phone) popup += '<br><a href="tel:' + r.phone.replace(/\s/g, '') + '">' + r.phone + '</a>';
        marker.bindPopup(popup);
        markers.push(marker);

        if (cards[i]) {
          cards[i].addEventListener('click', function () {
            map.flyTo([r.lat, r.lng], 14, { duration: 0.8 });
            marker.openPopup();
            cards.forEach(function (c) {
              c.classList.remove('revendeur-card--active');
            });
            cards[i].classList.add('revendeur-card--active');
          });

          marker.on('click', function () {
            cards.forEach(function (c) {
              c.classList.remove('revendeur-card--active');
            });
            cards[i].classList.add('revendeur-card--active');
            cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
        }
      });

      if (markers.length > 0) {
        var group = L.featureGroup(markers);
        map.fitBounds(group.getBounds().pad(0.15));
      } else {
        map.setView([42.6, 2.5], 9);
      }
    }

    var mapContainer = document.getElementById('revendeurs-map');
    if (!mapContainer) return;

    var script = document.createElement('script');
    script.src = mapContainer.dataset.leafletUrl;
    script.onload = initRevendeursMap;
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();
})();
